// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2U1n_","dragIcon":"SortableItem_dragIcon__9iJoU","disabled":"SortableItem_disabled__2oCtA"};